export function ShortDescription({ type, status, suburb }) {
  return (
    <div className={`property-card__short-description`}>
      {type} {status.toLowerCase()}{!!suburb && (` in ${suburb}`)}
    </div>
  );
}
